// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1M0_W","alert":"SettungsInbox_alert__2zt9S"};